import React, { useState } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import { toast } from "react-toastify";  // Make sure you have this for notifications
import { apiRequest } from "../../../util/apiUtils";
import { useNavigate } from "react-router-dom";
//import { encrypt } from "../../../helpers";

const CheckoutForm = ({
  paymentType,
  tableNumber,
  orderId,
  tipAmount,
  customPayAmount=0,
  noOfPerason=0,
  totalPeople=0,
  selectedItems=[]
}) => {
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();    
    if (!stripe || !elements) {
      return;
    }
    if (paymentType === "custom_amount" && !customPayAmount) {
        toast.error("Please enter an amount to continue the payment process.");
        return;
    } else if (paymentType === "split_amount" && !customPayAmount) {
        toast.error("Please select at least one person from 'Paying For'.");
        return;
    } else if (paymentType === "split_item" && !customPayAmount) {
        toast.error("Please select at least one item from 'Paying For'.");
        return;
    }
    setLoading(true);
    const cardElement = elements.getElement(CardElement);
    try {
      const { token, error } = await stripe.createToken(cardElement);
      if (error) {
        setErrorMessage(error.message);
        setLoading(false);
        return;
      }
      const response = await apiRequest("post","stripe-charge-create", {
        body: {
            paymentType,
            tableNumber,
            orderId,
            tipAmount,
            customPayAmount,
            noOfPerason,
            totalPeople,
            selectedItems,
            token: token.id
        }}
      );
      if (response.status === 200) { 
        let createString = response?.data?.data?.status+'|'+response?.data?.data?.orderId+'|'+response?.data?.data?.billAmount+'|'+response?.data?.data?.paymentType+'|'+response?.data?.data?.tableNumber+'|'+response?.data?.data?.amount+'|'+response?.data?.data?.date+'|'+response?.data?.data?.transactionId+'|'+response?.data?.data?.tableUid;
        const hash = window.btoa(createString);
        return navigate(`/bistro/payment-success/table/${response?.data?.data?.tableNumber}?hash=${hash}`)
      } else {

      } 
    } catch (err) {
      setErrorMessage("Something went wrong. Please try again.");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6 mt-3">
      <div className="card-element-container">
        <div
          className="card-element"
          style={{
            border: "1px solid #e1e1e1",
            padding: "10px",
            borderRadius: "8px",
            transition: "border-color 0.3s",
            backgroundColor: "#fff",
          }}
        >
          <CardElement
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  lineHeight: "24px",
                  fontFamily: "'Source Sans Pro', sans-serif",
                  color: "#495057",
                  placeholder: {
                    color: "#6c757d",
                  },
                  "::placeholder": {
                    color: "#6c757d",
                  },
                },
              },
            }}
          />
        </div>
      </div>

      {/* Error message */}
      {errorMessage && (
        <div className="error-message text-red-600 text-sm">
          {errorMessage}
        </div>
      )}

      {/* Submit Button */}
      <div className="flex justify-between items-center">
        <button
          type="submit"
          disabled={!stripe || loading}
          className={`submit-btn w-full py-2 text-white rounded-lg ${
            loading ? "bg-gray-400 cursor-not-allowed" : "!bg-black"
          }`}
        >
          {loading ? "Processing..." : "Pay Now"}
        </button>
      </div>
    </form>
  );
};

export default CheckoutForm;




















// import React, { useState,useEffect } from "react";
// import {
//   PaymentElement,
//   useStripe,
//   useElements
// } from "@stripe/react-stripe-js";
// import { apiRequest } from "../../../util/apiUtils";

// const CheckoutForm = ({paymentType,tableNumber,orderId}) => {
//   const stripe = useStripe();
//   const elements = useElements();
//   const [clientSecret, setClientSecret] = useState("");

//   useEffect(() => {
//     const fetchClientSecret = async () => {
//         const result = await apiRequest("post", `create-payment-intent`, {
//             body: {
//                 paymentType,
//                 tableNumber,
//                 orderId              
//             },
//         });
//         if (result.status === 200) {
//            setClientSecret(result?.data?.data?.client_secret);
//         }     
//     };    
//     fetchClientSecret();
//   }, []);

//   const handleSubmit = async (event) => {
//     event.preventDefault();    
//     if (!stripe || !elements) return;
//     const { error } = await stripe.confirmPayment({
//       elements,
//       confirmParams: {
//         return_url: window.location.href,
//       },
//     });

//     if (error) {
//       console.error(error.message);
//     } else {
//       // Handle successful payment
//       console.log("Payment successful!");
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit}>
//       <PaymentElement />
//       <button
//         type="submit"
//         disabled={!stripe || !clientSecret}
//       >
//         Pay Now
//       </button>
//     </form>
//   );
// };

// export default CheckoutForm;
